module.exports = __webpack_public_path__ + "img/top-bar-icon-time.5ac9f4fe.svg";